import React from 'react'
import { useTranslation } from 'react-i18next'
import CountType, { CountTypeStrings } from 'enums/CountType'

const Title = ({ countType }: { countType: CountTypeStrings }) => {
  const { t } = useTranslation()
  let title = ''
  switch (countType) {
    case CountType.POSTS:
      title = t('total_posts')
      break

    case CountType.AUTHORS:
      title = t('total_authors')
      break

    case CountType.MENTIONS:
    default:
      title = t('total_mentions')
  }

  return <div>{title}</div>
}

export default Title
